var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import BoxBG from '../../assets/images/hero/light_blue_bg.png';
import DownArrow from '../../assets/images/hero/down_arrow.svg';
import { gsapTimelineFromTo } from '../../GSAPAnimations/Animation/helper';
import { gsap, Power2 } from 'gsap';
import { Linear } from 'gsap';
import Typography from '../../GSAPAnimations/Typography';
import { v4 as uuid } from 'uuid';
import { HeroData } from '../../testing/homepageData';
import './animated.scss';
import AnimatedCarousel from './AnimatedCarousel';
var AnimatedHero = function (props) {
    var internalRef = props.internalRef;
    var data = (props === null || props === void 0 ? void 0 : props.data) || HeroData;
    var tl = gsap.timeline();
    var load = gsap.timeline();
    var animatedCarousel = useRef(null);
    // const safeBar = useRef(null) as any;
    var video = useRef(null);
    var bluebg = useRef(null);
    var headline = useRef(null);
    var boxbg = useRef(null);
    var stat = useRef(null);
    var mainSlider = useRef(document.getElementById('main-slider'));
    var slideHeader = useRef(null);
    var carouselCover = useRef(null);
    var thirdSlide = useRef(null);
    var childCarousel = useRef(null);
    var intelline = useRef(null);
    var leftArrow = useRef(null);
    var rightArrow = useRef(null);
    var overlay = useRef(null);
    var closeButton = useRef(null);
    var isMouseEnterOnce = useRef(false);
    var headingConfigs = function (ref) {
        return (document === null || document === void 0 ? void 0 : document.getElementById(ref)) && {
            config: {
                autoAlpha: 0,
                y: 100,
            },
            config2: {
                duration: 0.35,
                autoAlpha: 1,
                y: 0,
                ease: Linear.easeIn,
                scrollTrigger: {
                    trigger: document.getElementById(ref) || '',
                    start: 'top center',
                    toggleActions: 'play none none reverse',
                },
            },
        };
    };
    var handleHover = function (event) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((event.type === 'mouseenter' ||
            (event.type === 'mouseleave' &&
                ((_b = (_a = event.fromElement) === null || _a === void 0 ? void 0 : _a.classList) === null || _b === void 0 ? void 0 : _b.contains('swiper-pagination')))) &&
            isMouseEnterOnce.current === false &&
            !((_d = (_c = event.toElement) === null || _c === void 0 ? void 0 : _c.classList) === null || _d === void 0 ? void 0 : _d.contains('swiper-pagination'))) {
            isMouseEnterOnce.current = true;
            tl.play();
            video.current.forEach(function (it) {
                if (isVisible(it)) {
                    it.play();
                }
            });
            // video.current.play();
            // safeBar.current.style.display = 'none';
            tl.to([animatedCarousel.current], {
                height: '1050px',
                clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 80%)',
                ease: Linear.easeIn,
                duration: 0.2,
                repeat: 0,
                modifiers: {
                    height: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = 'auto';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = '900px';
                        }
                        if (window.innerWidth >= 835 && window.innerWidth < 1024) {
                            value = '950px';
                        }
                        if (window.innerWidth >= 1024 && window.innerWidth < 1440) {
                            value = '975px';
                        }
                        return value;
                    },
                    clipPath: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = 'polygon(0 0, 100% 0%, 100% 100%, 0 100%)';
                        }
                        if (window.innerWidth > 500 && window.innerWidth <= 1440) {
                            value = 'polygon(0 0, 100% 0%, 100% 100%, 0 85%)';
                        }
                        return value;
                    },
                },
            });
            tl.to(["#main-slider", video.current], {
                maxWidth: '700px',
                ease: Linear.easeIn,
                duration: 0.2,
                repeat: 0,
                modifiers: {
                    maxWidth: function (val) {
                        var value = val;
                        if (window.innerWidth >= 835 && window.innerWidth < 1440) {
                            value = '50vw';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = '375px';
                        }
                        if (window.innerWidth <= 500) {
                            value = '100%';
                        }
                        return value;
                    },
                },
            });
            tl.to([video.current], {
                maxWidth: '100%',
                width: '100%',
                duration: 0.2,
                filter: 'brightness(40%)',
                ease: Linear.easeIn,
                repeat: 0,
            });
            tl.to([video.current], {
                height: '1180px',
                marginTop: '0',
                duration: 0.2,
                ease: Linear.easeIn,
                repeat: 0,
                modifiers: {
                    height: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = 'auto';
                        }
                        return value;
                    },
                },
            }).to([closeButton.current], {
                display: 'flex',
                duration: 0.2,
                ease: Linear.easeIn,
                modifiers: {
                    display: function (val) {
                        var value = val;
                        if (window.innerWidth > 500) {
                            value = 'none';
                        }
                        return value;
                    },
                },
            });
            tl.to(["#default-cover"], {
                opacity: 0,
                duration: 0.4,
                ease: Linear.easeOut,
                yPercent: 70,
            }).to(["#default-cover"], {
                display: 'none',
            });
            tl.fromTo(["#child-slider"], {
                display: 'none',
                yPercent: -20,
                opacity: 0,
            }, {
                display: 'block',
                yPercent: 0,
                opacity: 1,
                duration: 0.2,
                ease: Linear.easeIn,
            });
            tl.to([stat.current], {
                display: 'block',
                duration: 0.3,
                ease: Linear.easeIn,
            });
        }
        if ((event.type === 'mouseleave' ||
            (event.type === 'mouseenter' &&
                ((_f = (_e = event.toElement) === null || _e === void 0 ? void 0 : _e.classList) === null || _f === void 0 ? void 0 : _f.contains('swiper-pagination')))) &&
            isMouseEnterOnce.current === true &&
            !((_h = (_g = event.fromElement) === null || _g === void 0 ? void 0 : _g.classList) === null || _h === void 0 ? void 0 : _h.contains('swiper-pagination'))) {
            if (window && window.innerWidth > 500) {
                //setTimeout(() => {
                //  safeBar.current.style.display = 'block';
                isMouseEnterOnce.current = false;
                tl.play();
                /*video.current.forEach((it: HTMLVideoElement) => {
                  if (isVisible(it)) {
                    it.pause();
                  }
                });*/
                // video.current.pause();
                tl.restart();
                tl.clear();
                tl.to([stat.current], {
                    display: 'none',
                    duration: 0.3,
                    ease: Linear.easeIn,
                });
                tl.to([animatedCarousel.current], {
                    height: '1180px',
                    ease: Linear.easeOut,
                    clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 80%)',
                    duration: 0.2,
                    repeat: 0,
                    modifiers: {
                        height: function (val) {
                            var value = val;
                            if (window.innerWidth <= 500) {
                                value = 'auto';
                            }
                            if (window.innerWidth > 500 && window.innerWidth < 835) {
                                value = '1000px';
                            }
                            if (window.innerWidth >= 835 && window.innerWidth < 1440) {
                                value = '1050px';
                            }
                            return value;
                        },
                        clipPath: function (val) {
                            var value = val;
                            if (window.innerWidth <= 500) {
                                value = 'polygon(0 0, 100% 0%, 100% 100%, 0 93%)';
                            }
                            if (window.innerWidth > 500 && window.innerWidth < 835) {
                                value = 'polygon(0 0, 100% 0%, 100% 100%, 0 85%)';
                            }
                            if (window.innerWidth >= 835 && window.innerWidth <= 1440) {
                                value = 'polygon(0 0, 100% 0%, 100% 100%, 0 85%)';
                            }
                            return value;
                        },
                    },
                }).to(["#main-slider", video.current], {
                    maxWidth: '700px',
                    ease: Linear.easeIn,
                    duration: 0.2,
                    repeat: 0,
                    modifiers: {
                        maxWidth: function (val) {
                            var value = val;
                            if (window.innerWidth >= 835 && window.innerWidth < 1440) {
                                value = '50vw';
                            }
                            if (window.innerWidth > 500 && window.innerWidth < 835) {
                                value = '375px';
                            }
                            if (window.innerWidth <= 500) {
                                value = '86.5vw';
                            }
                            return value;
                        },
                    },
                });
                tl.fromTo([video.current], {
                    marginTop: '29em',
                    width: '100%',
                    duration: 0.2,
                    ease: Linear.easeIn,
                    repeat: 0,
                    modifiers: {
                        marginTop: function (val) {
                            var value = val;
                            if (window.innerWidth <= 500) {
                                value = '62vh';
                            }
                            if (window.innerWidth > 500 && window.innerWidth < 835) {
                                value = '29em';
                            }
                            return value;
                        },
                        width: function (val) {
                            var value = val;
                            if (window.innerWidth >= 835) {
                                value = 'auto';
                            }
                            return value;
                        },
                    },
                }, {
                    height: '750px',
                    marginTop: '29em',
                    duration: 0.2,
                    ease: Linear.easeIn,
                    repeat: 0,
                    modifiers: {
                        height: function (val) {
                            var value = val;
                            if (window.innerWidth <= 500) {
                                value = '400px';
                            }
                            if (window.innerWidth > 500 && window.innerWidth < 835) {
                                value = '540px';
                            }
                            // if (window.innerWidth > 835 && window.innerWidth < 1440) {
                            //   value = '50vw';
                            // }
                            return value;
                        },
                        marginTop: function (val) {
                            var value = val;
                            if (window.innerWidth <= 500) {
                                value = '62vh';
                            }
                            // if (window.innerWidth > 500 && window.innerWidth < 835) {
                            //   value = '29em';
                            // }
                            // if (window.innerWidth > 835 && window.innerWidth < 1440) {
                            //   value = '29em';
                            // }
                            return value;
                        },
                    },
                });
                tl.to([childCarousel.current], {
                    display: 'none',
                    scaleY: 0.5,
                    opacity: 0,
                    duration: 0.3,
                    ease: Linear.easeIn,
                });
                //}, 1000);
            }
        }
        return;
    };
    var onClose = function (event) {
        if (event.type === 'click') {
            /* video.current.forEach((it: HTMLVideoElement) => {
              if (isVisible(it)) {
                it.pause();
              }
            });*/
            // video.current.pause();
            isMouseEnterOnce.current = false;
            tl.restart();
            tl.clear();
            tl.to([closeButton.current], {
                display: 'none',
                duration: 0.3,
                ease: Linear.easeOut,
                modifiers: {
                    display: function (val) {
                        var value = val;
                        if (window.innerWidth > 500) {
                            value = 'none';
                        }
                        return value;
                    },
                },
            })
                .to([stat.current], {
                display: 'none',
                duration: 0.3,
                ease: Linear.easeIn,
            })
                .to([animatedCarousel.current], {
                height: '1180px',
                ease: Linear.easeOut,
                clipPath: 'polygon(0 0, 100% 0%, 100% 100%, 0 80%)',
                duration: 0.2,
                repeat: 0,
                modifiers: {
                    height: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = 'auto';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = '1000px';
                        }
                        return value;
                    },
                    clipPath: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = 'polygon(0 0, 100% 0%, 100% 100%, 0 93%)';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = 'polygon(0 0, 100% 0%, 100% 100%, 0 85%)';
                        }
                        return value;
                    },
                },
            })
                .to(["#main-slider", video.current], {
                maxWidth: '700px',
                ease: Linear.easeIn,
                duration: 0.2,
                repeat: 0,
                modifiers: {
                    maxWidth: function (val) {
                        var value = val;
                        if (window.innerWidth >= 835) {
                            value = '700px';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = '375px';
                        }
                        if (window.innerWidth <= 500) {
                            value = '86.5vw';
                        }
                        return value;
                    },
                },
            });
            tl.fromTo([video.current], {
                marginTop: '29em',
                duration: 0.2,
                ease: Linear.easeIn,
                repeat: 0,
                modifiers: {
                    marginTop: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = '62vh';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = '29em';
                        }
                        return value;
                    },
                },
            }, {
                height: '750px',
                marginTop: '29em',
                duration: 0.2,
                ease: Linear.easeIn,
                repeat: 0,
                modifiers: {
                    height: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = '400px';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = '490px';
                        }
                        return value;
                    },
                    marginTop: function (val) {
                        var value = val;
                        if (window.innerWidth <= 500) {
                            value = '62vh';
                        }
                        if (window.innerWidth > 500 && window.innerWidth < 835) {
                            value = '29em';
                        }
                        return value;
                    },
                },
            });
            tl.to([childCarousel.current], {
                display: 'none',
                scaleY: 0.5,
                opacity: 0,
                duration: 0.3,
                ease: Linear.easeIn,
            });
        }
    };
    var isVisible = function (elem) {
        return elem.offsetWidth > 0 || elem.offsetHeight > 0;
    };
    useEffect(function () {
        document.documentElement.scrollTop = 0;
    }, []);
    useEffect(function () {
        if (window) {
            window.addEventListener('DOMContentLoaded', function () {
                bluebg.current = document.getElementById('hero-blue-background');
                headline.current = document.getElementById('headline-container');
                boxbg.current = document.getElementById('hero-blue-box');
                animatedCarousel.current = document.getElementById('animated-carousel');
                // safeBar.current = document.getElementById('safeBar');
                childCarousel.current = document.getElementById('child-slider');
                mainSlider.current = document.getElementById('main-slider');
                video.current = document.querySelectorAll('.animated-carousel__video');
                slideHeader.current = document.getElementById('slide-header');
                carouselCover.current = document.getElementById('default-cover');
                intelline.current = document.getElementById('intelline');
                closeButton.current = document.getElementById('close-button');
                load.fromTo([bluebg.current], {
                    height: '0px',
                }, {
                    height: '1050px',
                    duration: 0.5,
                    transformOrigin: 'top',
                    ease: Linear.easeIn,
                });
                load.fromTo([headline.current], {
                    opacity: 0,
                    y: 30,
                }, {
                    opacity: 1,
                    y: 0,
                    ease: Power2.easeOut,
                });
                load.fromTo([boxbg.current], {
                    scaleX: 0.5,
                    opacity: 0,
                }, {
                    scaleX: 1,
                    opacity: 1,
                    duration: 0.4,
                    transformOrigin: 'left',
                    ease: Linear.easeIn,
                });
                load.fromTo([animatedCarousel.current], {
                    x: 700,
                }, {
                    display: 'flex',
                    x: 0,
                    duration: 0.5,
                    ease: Linear.easeIn,
                });
                load.fromTo([carouselCover.current], {
                    opacity: 0,
                }, {
                    opacity: 1,
                    duration: 0.2,
                    ease: Linear.easeIn,
                });
                load.fromTo([intelline.current], {
                    width: 0,
                }, {
                    width: '100%',
                    duration: 0.4,
                    ease: Linear.easeIn,
                    transformOrigin: 'right',
                });
                onWindowSizeChanged();
            });
        }
    }, [tl]);
    var onWindowSizeChanged = function () {
        if (window) {
            window.addEventListener('resize', function () {
                if (window.innerWidth > 500) {
                    tl.restart();
                }
            });
        }
    };
    return (_jsxs("section", __assign({ ref: internalRef, className: "hero md:scroll-mb-48 xl:scroll-mb-56 " }, { children: [_jsx("div", __assign({ id: "hero-blue-background", ref: bluebg, className: "static-background" }, { children: _jsx("img", { src: BoxBG, id: "hero-blue-box", ref: boxbg, className: "box-background" }, void 0) }), void 0),
            _jsx(HeroHeadline, { data: data, headingConfigs: headingConfigs("heading--" + uuid()), refs: { stat: stat, headline: headline }, methods: { gsapTimelineFromTo: gsapTimelineFromTo } }, void 0),
            _jsx(AnimatedCarousel, { data: data, headingConfigs: headingConfigs("heading--" + uuid()), refs: {
                    animatedCarousel: animatedCarousel,
                    mainSlider: mainSlider,
                    video: video,
                    overlay: overlay,
                    carouselCover: carouselCover,
                    intelline: intelline,
                    thirdSlide: thirdSlide,
                    childCarousel: childCarousel,
                    leftArrow: leftArrow,
                    rightArrow: rightArrow,
                    closeButton: closeButton,
                    stat: stat,
                    slideHeader: slideHeader,
                }, methods: {
                    handleHover: handleHover,
                    gsapTimelineFromTo: gsapTimelineFromTo,
                    onClose: onClose,
                } }, void 0)] }), void 0));
};
var HeroHeadline = function (props) {
    var _a, _b, _c, _d;
    return (_jsxs("div", __assign({ className: "headline-container snap-start", id: "headline-container", ref: (_a = props.refs) === null || _a === void 0 ? void 0 : _a.headline }, { children: [_jsx(Typography, { id: uuid(), title: (_b = props.data) === null || _b === void 0 ? void 0 : _b.title, variant: "h1", classes: 'headlineText', animate: (_c = props.methods) === null || _c === void 0 ? void 0 : _c.gsapTimelineFromTo, configs: props.headingConfigs }, void 0),
            ((_d = props.data) === null || _d === void 0 ? void 0 : _d.showArrowIcon) && (_jsx("div", __assign({ className: "downarrow" }, { children: _jsx("img", { src: DownArrow }, void 0) }), void 0))] }), void 0));
};
export default AnimatedHero;
